module.exports = __webpack_public_path__ + "static/media/landing_wallpaper.1a2c8e03.jpg";